import { JSX } from 'react';

/**
 * Available features for the CatalogExplorerPage.
 *
 * Features with `defaultEnabled: true` are active unless explicitly disabled:
 *   { [CatalogFeature.KindSelector]: false }
 *
 * Features with `defaultEnabled: false` must be explicitly enabled:
 *   CatalogFeature.OwnerSelector
 *   { [CatalogFeature.OwnerSelector]: true }
 */
export enum CatalogFeature {
  KindSelector = 'KindSelector',
  TypeSelector = 'TypeSelector',
  Owned = 'Owned',
  OwnerSelector = 'OwnerSelector',
  BusinessProductUnitSelector = 'BusinessProductUnitSelector',
  LifecycleSelector = 'LifecycleSelector',
  TagSelector = 'TagSelector',
  ProcessingStatus = 'ProcessingStatus',
  NamespaceSelector = 'NamespaceSelector',
}

export type FeatureDefinition = {
  defaultEnabled: boolean;
  render: () => JSX.Element;
};

export type FeatureEntry = CatalogFeature | Partial<Record<CatalogFeature, boolean>>;
